import { useSelector } from "react-redux";
import { useState } from "react";
import { isLoadingSelector } from "store1/advance data/advanceData.slice";
import InvoiceData from "./InvoiceList/invoiceListData";

const InvoiceDataWrapper = () => {
    const [pageSize, setPageSize] = useState(10);
    const [pageIndex, setPageIndex] = useState(0);
    const isLoadingInvoices = useSelector(isLoadingSelector);
    return (
        <InvoiceData
            isLoadingData={Boolean(isLoadingInvoices)}
            pageIndex={pageIndex}
            setPageIndex={setPageIndex}
            pageSize={pageSize}
            setPageSize={setPageSize}
        />
    );
};

export default InvoiceDataWrapper;